import React from "react";

// Emergent-managed Google sign-in button.
// Redirects to Emergent's OAuth start URL; comes back to `${origin}/dashboard#session_id=…`
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleSignInButton({ label = "Continue with Google", testid = "google-signin-btn" }) {
  const go = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid={testid}
      className="flex w-full items-center justify-center gap-3 rounded-xl border-2 border-sarthi-border bg-white px-4 py-3 text-base font-bold text-sarthi-text shadow-sm transition hover:border-sarthi-primary hover:shadow"
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
        <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44c-.28 1.42-1.11 2.63-2.36 3.44v2.86h3.82c2.24-2.06 3.53-5.11 3.53-8.54z" />
        <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.82-2.96c-1.07.72-2.44 1.14-4.11 1.14-3.16 0-5.83-2.14-6.79-5H1.28v3.13C3.25 21.31 7.31 24 12 24z" />
        <path fill="#FBBC05" d="M5.21 14.27a7.2 7.2 0 0 1 0-4.55V6.6H1.28a12 12 0 0 0 0 10.8l3.93-3.13z" />
        <path fill="#EA4335" d="M12 4.75c1.77 0 3.36.61 4.61 1.8l3.4-3.4C17.94 1.19 15.23 0 12 0 7.31 0 3.25 2.69 1.28 6.6l3.93 3.12C6.17 6.89 8.84 4.75 12 4.75z" />
      </svg>
      {label}
    </button>
  );
}
